import { ReactElement, ReactNode } from 'react';

export type ConditionalParentProps = {
  condition: boolean;
  parent: (children: ReactNode) => ReactElement;
  children: ReactNode;
};

export default function ConditionalParent({ condition, parent, children }: ConditionalParentProps) {
  return condition ? parent(children) : children;
}
